export default __webpack_public_path__ + "static/media/logo6.670d26bf.png";